import React, { useRef, useState, useEffect } from 'react';
import ChangePlanHeader from 'components/ChangePlanHeader/ChangePlanHeader';
import { FormattedNumber, FormattedDate } from 'react-intl';
import ReactToPrint from 'react-to-print';
import styles from './UpdatePaymentPlanConfirmTablePageData.module.scss';
import { useHistory } from 'react-router-dom';
import PageLink from 'components/PageLink/PageLink';
import Button from 'components/Button/Button';
import { PrintUpdatePaymentPlanConfirmTable } from './PrintUpdatePaymentPlanConfirmTable';
import http from 'app/http';
import RepaymentList from 'components/RepaymentList/RepaymentList';
import { getGTMVariables, getGTMVariablesPageView } from 'common/helpers/Gtm';

interface Props {
    PageData?: any;
    Model?: any;
    LayoutModel?: any;
}
const UpdatePaymentPlanConfirmTablePageData = (props: Props) => {
    const { Model, PageData, LayoutModel } = props;

    let InstallementTable = [...Model.InstallmentPlan];
    InstallementTable.splice(-1);
    let InstallementLastTable = Model.InstallmentPlan.slice(-1);
    const [disablebutton, setDisablebutton] = useState(false);

    const componentRef = useRef(null);
    const [mainCotent, setmainContent] = useState(true);
    const history = useHistory();
    const getPathnameFromUrl = (url: string) => {
        const link = new URL(url);

        return link.pathname + link.search;
    };
    const submitClick = async (e: any) => {
        setmainContent(false);        
        setDisablebutton(true);
        try {
            const response = await http.get(
                Model.ConfirmUrl,
                // Convert object into string
                {
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded',
                    },
                },
            );
            if (response && response.data) {
                // Get pathname from enpoint url, pathname will be used for redirect and as a key in content state
                //const nextPagePath = getPathnameFromUrl(response.data.data);
                const nextPagePath = getPathnameFromUrl(response.data.data);
                history.push(nextPagePath, {
                    noRefresh: false,
                });
            }
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        if (LayoutModel != undefined) {
          var userid = LayoutModel?.Profiles.length>0 ? LayoutModel?.Profiles[0].DebtReference : '';
          var isLoggedIn = LayoutModel?.HasProfile;
          var lang = PageData?.Language;
          var env = LayoutModel?.Environment;
          var reg = LayoutModel?.CountryCode;
          getGTMVariables(userid, isLoggedIn, lang, reg, env,LayoutModel?.IsLoggedInUserSecured, LayoutModel?.SecuredCaseStatus);
          getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
        }
      }
        , [LayoutModel]);
    return (
        <div className={styles.wrapper}>
            <div className="Section--secondaryBg">
                <div className="Page-container PageContainer--transparent">
                    <section className="Section Section--portal">
                        <div id="main-Content">
                            <h1 className="Heading u-sm-textCenter">{PageData.Heading}</h1>
                           
                        <RepaymentList
                          Heading={PageData?.PaymentDetailsHeader}
                          Monthlylabel={PageData?.PaymentPlanItemNumberOfRegularPaymentsLabel}
                          Mothlyamount={Model?.PlanDetails?.PlanDetailsNumberofInstallments}                          
                          Finallabel={PageData?.PaymentPlanItemLastPaymentValueLabel}
                          FinalAmount={Model?.PlanDetails?.PlanDetailsFinalPaymentAmount}
                          Totaltext={PageData?.PlanDetailsTotalPlanLabel}
                          Totalamount={Model?.FormattedCurrencyTotalAmount}
                          BalanceLabel = {PageData?.PaymentPlanItemDebtBalanceLabel}
                          BalanceAmount = {Model?.PlanDetails.PlanDetailsCurrentBalance} 
                          PaymentMethodLabel = {PageData?.PaymentPlanItemPaymentMethodLabel}   
                          PaymentMethod = {Model?.PlanDetails.PlanDetailsPaymentMethod} 
                          CustomerNumberLabel = {PageData?.CustomerNumber}     
                          CustomerNumber = {Model?.PlanDetails?.PlanDetailsCustomerNumber}  
                          PlanDueDate = {Model?.PlanDetails.PlanDetailsFirstPaymentDueDate}  
                          PlanDueDateInfoText = {PageData?.FirstPaymentDueDateDetails}  
                          UpdatePlanConfirm = {true}          
                        />

                            <div className="Grid Grid--white Grid--gutterH">
                                <div className="Grid-cell u-size1of1">
                                    <div className="HeadingContentSplit">
                                        <h3 className="Heading HeadingContentSplit-heading">
                                            {PageData.PlanSummaryHeadingLabel}
                                        </h3>
                                        <div className="HeadingContentSplit-content">
                                            {(Model.IsPrintoutsEnabled) &&
                                                (
                                                    <div>
                                                        <ReactToPrint
                                                            trigger={() => (
                                                                <a className="Link-icon Link-print">
                                                                    <>{PageData?.PlanTablePrintLabel}</>
                                                                </a>
                                                            )}
                                                            content={() => componentRef.current}
                                                        />
                                                        <div style={{ display: 'none' }}>
                                                            <PrintUpdatePaymentPlanConfirmTable ref={componentRef} {...props} />
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="Grid-cell u-lg-size1of1">
                                    <div className="Table-wrapper Table--verticalScroll">
                                        <table className="Table">
                                            <thead>
                                                <tr>
                                                    <th>{PageData.PlanTablePaymentColumnLabel}</th>
                                                    <th>{PageData.PlanTableDateColumnLabel}</th>
                                                    <th>{PageData.PlanTableAmountColumnLabel}</th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                                {InstallementTable.map((item: { Number: any; Date: any; Amount: any; }) =>

                                                    <tr>
                                                        <td>{item.Number}</td>
                                                        <td><FormattedDate
                                                            value={item?.Date}
                                                        /></td>
                                                        <td> <FormattedNumber
                                                            style="currency"
                                                            currency={Model?.Currency}
                                                            value={item?.Amount / 100}
                                                        />
                                                        </td>
                                                    </tr>
                                                )}
                                                <tr>
                                                    <td className="emptyRow tableColSpan"></td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <td>{PageData.PlanTableFinalPaymentLabel}</td>
                                                    <td>
                                                        <FormattedDate
                                                            value={InstallementLastTable[0].Date}
                                                        />
                                                    </td>
                                                    <td>
                                                        <FormattedNumber
                                                            style="currency"
                                                            currency={Model?.Currency}
                                                            value={InstallementLastTable[0].Amount / 100}
                                                        />
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>{PageData.PlanTableTotalLabel}</td>
                                                    <td></td>
                                                    <td>
                                                        <FormattedNumber
                                                            style="currency"
                                                            currency={Model?.Currency}
                                                            value={Model.TotalAmount / 100}
                                                        />
                                                    </td>
                                                </tr>
                                            </tfoot>
                                        </table>

                                    </div>

                                </div>
                            </div>

                            {!Model.IsPaymentError && (
                                <div className="Grid">
                                    <div className="Grid-cell">
                                        <div className="ButtonBar ButtonBar--spaceBetween ButtonBar-sm--spaceBetween">

                                            <PageLink
                                                className="Button Button--gray"
                                                text={PageData.BackBtnLabel}
                                                url={Model.BackUrl}
                                            />

                                            <Button
                                                text={PageData.ConfirmBtnLabel}
                                                className={disablebutton ? 'Button is-disabled' : 'Button'}
                                                onClick={submitClick}
                                            />
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                    </section>
                </div>
            </div>
        </div>
    );
};

export default UpdatePaymentPlanConfirmTablePageData;
